import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices";
import SupplierInvoiceDetailsModal from "./SupplierInvoiceDetailsModal";

const ViewSupplierInvoicesWzBalances = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();

  // State
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [view_details, setView_details] = useStateCallback(false);

  // Fetch invoices with balance > 0
  const fetchSupplierInvoices = async () => {
    setLoading(true);
    try {
      const server_response =
        await ajaxSupplierInvoices.fetchSupplierInvoicesWz_balances({});
      if (server_response.status === "OK") {
        // Filter invoices with balance > 0
        const pendingInvoices = server_response.details.filter(
          (inv) => parseFloat(inv.balance) > 0
        );
        setInvoices(pendingInvoices);
      } else {
        toast.error(server_response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSupplierInvoices();
  }, []);

  // Modal handler
  const handleView_details = (invoiceId) => {
    setView_details(false, () =>
      setView_details(<SupplierInvoiceDetailsModal invoiceId={invoiceId} />)
    );
  };

  return (
    <AppContainer title="Invoices Not Fully Paid">
      <div className="container-fluid">
        <Toaster />
        {view_details}

        {/* Create button */}
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary shadow-sm"
              onClick={() => navigate("/supplier_invoices/create")}
            >
              <i className="fa fa-plus me-2"></i> Create Supplier Invoice
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light fw-bold">
            <i className="fa fa-list me-2"></i> Organisation Supplier Invoices
            not fully paid
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Delivery Reff</th>
                    <th>Supplier</th>
                    <th>Contact</th>
                    <th>Amount</th>
                    <th>Balance</th>
                    <th>Date</th>
                    <th>Created By</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(invoices) && invoices.length > 0 ? (
                    invoices.map((inv, key) => (
                      <tr key={inv.id}>
                        <td>{key + 1}</td>
                        <td>{inv.invoice_no}</td>
                        <td>{inv.delievery_reff_no}</td>
                        <td>{inv.buss_name}</td>
                        <td>{inv.buss_contact}</td>
                        <td>{parseFloat(inv.amount).toLocaleString()}</td>
                        <td>
                          <span className="badge bg-warning text-dark">
                            {parseFloat(inv.balance).toLocaleString()}
                          </span>
                        </td>
                        <td>{inv.date_created}</td>
                        <td>{inv.created_by}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => handleView_details(inv.id)}
                          >
                            <i className="fa fa-eye me-1"></i> Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-3">
                        {loading
                          ? "Loading invoices..."
                          : "No pending invoices found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};

export default ViewSupplierInvoicesWzBalances;
